import store from '@/store'

let isRefreshing = false // 是否正在刷新 token
let retryQueue = [] // 等待重试的请求队列

export default {
  common: {
    baseUrl: process.env.VUE_APP_HTTP,
    data: {},
    header: {
      "Content-Type": "application/json",
    },
    method: "POST",
    dataType: "json"
  },

  request(options) {
    // 自动拼接基础地址
    if (!options.url.startsWith('http')) {
      options.url = this.common.baseUrl + options.url
    }

    // 合并配置
    options.data = options.data || this.common.data
    options.header = { ...this.common.header, ...(options.header || {}) }
    options.method = options.method || this.common.method
    options.dataType = options.dataType || this.common.dataType

    // 自动带上 token
    const token = uni.getStorageSync('token')
    if (token) {
      options.header.Authorization = 'Bearer ' + token
    }

    return new Promise((resolve, reject) => {
      const task = uni.request({
        ...options,
        success: async (result) => {
          const data = result.data || {}
          const code = data.code
          // ======================
          // 401 刷新 token 核心逻辑
          // ======================
          if (code === 401) {
            // 创建一个等待重试的 Promise
            const retryPromise = new Promise((resolveRetry) => {
              retryQueue.push(() => {
                resolveRetry(this.request(options)) // 刷新后重新请求
              })
            })

            // 如果没有在刷新，才执行刷新
            if (!isRefreshing) {
              isRefreshing = true
              try {
                const refreshToken = uni.getStorageSync('refreshToken')
                if (!refreshToken) throw new Error('无刷新凭证')

                // 执行刷新
                await store.dispatch('user/refreshToken', refreshToken)

                // 刷新成功 → 执行所有等待的请求
                isRefreshing = false
                retryQueue.forEach(cb => cb())
                retryQueue = []
              } catch (e) {
                // 刷新失败 → 清空队列 + 登出
                retryQueue = []
                isRefreshing = false
                store.dispatch('user/logout')
                reject(data)
                return
              }
            }

            // 等待重试结果并返回
            try {
              const res = await retryPromise
              resolve(res)
            } catch (err) {
              reject(err)
            }
            return
          }

          // 正常业务状态码处理
          if (code !== 200) {
            reject(data)
          } else {
            resolve(data)
          }
        },
        fail: (err) => {
          reject(err)
        }
      })
    })
  }
}